import Layout from 'HorizontalMenu/Menu'
import React from 'react'
import { Link } from 'react-router-dom'
import { Col, Container, Navbar, Row } from 'reactstrap'
import ImportUserSummary from 'Users/importUser/ImportUserSummary'
import ImportUserTable from 'Users/importUser/ImportUserTable'

const ViewHistory = () => {
    return (
        <React.Fragment>
            <Layout>
                <Navbar />
            </Layout>
            <div className="page-content">
                <Container fluid>
                    <Row className='pb-2 mb-2'>
                        <Col sm={2} className="d-flex align-items-center">
                            <Link className="btn_size_cstm mr-1 btn btn-primary" to="/users/history">
                                <i className="bx bx-chevron-left me-1" /> Back
                            </Link>
                        </Col>
                        <Col lg={9} className="d-flex align-items-center mb-2">
                            <h2 className="page_title pos-center text-uppercase mb-0">
                                History Details
                            </h2>
                        </Col>
                        <div className='mb-2'>
                            <ImportUserSummary />
                        </div>
                        <ImportUserTable />
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default ViewHistory